import React, { FC } from 'react';
import { Tooltip } from '@clearcover/atlas';

import styles from './styles.module.css';

export type PolicySystemOfRecordIndicatorProps = {
  systemOfRecord: 'one_inc_3' | 'one_inc_4' | 'clearcover' | 'missing';
};

const SOR_MAP: Record<string, string> = {
  one_inc_3: '3.0',
  one_inc_4: '4.0',
  clearcover: 'Core',
};

export const PolicySystemOfRecordIndicator: FC<
  PolicySystemOfRecordIndicatorProps
> = ({ systemOfRecord }) => {
  const sor = SOR_MAP[systemOfRecord];
  return (
    <Tooltip
      position="top"
      tooltip={`The system of record for this policy is ${sor}`}
    >
      <span className={styles.indicator}>{sor}</span>
    </Tooltip>
  );
};

PolicySystemOfRecordIndicator.displayName = 'PolicySystemOfRecordIndicator';
